import { z } from 'zod';
import { ServiceOrderNoteType } from '@mews-commander/data-access';
import { ServiceOrderNote } from '@mews-commander/types';

const ServiceOrderNoteSchema = z.object({
    id: z.string(),
    serviceOrderId: z.string(),
    text: z.string(),
    createdUtc: z.string(),
    type: z.nativeEnum(ServiceOrderNoteType),
}) satisfies z.ZodType<ServiceOrderNote>;

const NoteWithRankedHashSchema = ServiceOrderNoteSchema.extend({
    rankedHash: z.string(),
});

export type NoteWithRankedHash = z.infer<typeof NoteWithRankedHashSchema>;

const CompactedNoteSchema = NoteWithRankedHashSchema.extend({
    ids: z.array(z.string()),
    serviceOrderIds: z.array(z.string()),
});

export type CompactedNote = z.infer<typeof CompactedNoteSchema>;

export const NotesFormSchema = z.object({
    noteText: z.string().optional(),
    notes: z.array(CompactedNoteSchema).default([]),
});

export type NotesFormValues = z.infer<typeof NotesFormSchema>;
